import Swiper from "swiper";
import { Autoplay, A11y, EffectFade, Navigation } from "swiper/modules";

function initSlider(): void {
  const slideshow = document.querySelector(".js-announcement-bar-slider");

  if (slideshow instanceof HTMLElement) {
    const swiperAutoPlayOptions = slideshow.dataset.autoplayOptions
      ? JSON.parse(slideshow.dataset.autoplayOptions)
      : { autoplay: false };

    new Swiper(slideshow, {
      loop: true,
      modules: [Autoplay, A11y, EffectFade, Navigation],
      slidesPerView: 1,
      a11y: {
        enabled: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        slideChange: (swiper) => {
          if (!swiper) return;
          const index = swiper.activeIndex;
          const currentSlide = swiper.slides[index];
          const swiperElem = swiper.el;
          if (currentSlide && swiperElem) {
            const color = currentSlide.style.color || "#ffffff";
            swiperElem.style.setProperty("--arrow-color", color);
          }
        },
      },
      ...swiperAutoPlayOptions,
    });
  }
}

/**
 * Initializes the announcement bar Swiper slider.
 * Handles the case where the async script loads after DOMContentLoaded has
 * already fired (common on Safari / iOS), which would cause the listener to
 * never execute.
 */
export function initializeAnnouncementBar(): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSlider, { once: true });
  } else {
    initSlider();
  }
}
